




























import { Component, Prop, Vue } from "vue-property-decorator";

import { UserConfigColors } from "@/userConfigColors/userConfigColors";
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class FontConvertModal extends Vue 
{
    private isVisible = false;
    private fontNames : Array<string> = [];
    private completion : (() => void) | null = null;

    public open(fontNames : Array<string>, completion : () => void)
    {
        this.isVisible = true;
        this.fontNames = fontNames;
        this.completion = completion;

        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    private onOk()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
        
        this.isVisible = false;
        if(this.completion != null) { this.completion(); }
    }

    private get title() { return "利用できないフォントがあります"; }
    private get message() { return "以下のフォントは代替フォントで表示されます。"; }

    private get fontNamesContent()
    {
        var text = "";
        for(var i = 0; i < this.fontNames.length; ++i)
        {
            var fontName = this.fontNames[i];
            if(text.length > 0) { text += "\n"; }
            text += fontName;
        }
        return text;
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
